import React from 'react';

import Typography from '../../library/typography/typography';

import './flag.scss';

interface FlagProps {
  children: React.ReactNode;
  className?: string;
  renderIcon?: React.ReactNode;
}

function Flag(props: FlagProps) {
  const { children, className = '', renderIcon } = props;

  return (
    <div
      className={`flag ${className}`}
      data-testid="flag-container"
      styleName="container"
    >
      {renderIcon}
      <Typography
        className="flag__text"
        data-testid="flag__text"
        size="small"
        styleName="text"
        tag="span"
        weight="bold"
      >
        {children}
      </Typography>
    </div>
  );
}

export default Flag;
